/* Suresh Peddavoora 12/23/2022 2700632669 Fixed Confirm password TextField ValidationAlignments.
*/
import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Navigation from '../../../assets/images/Navigation.png';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import PageLoader from '../../../components/PageLoader';
import {Visibility, VisibilityOff} from '@material-ui/icons';
import {useForm} from 'react-hook-form';
import {TextField, FormHelperText, InputAdornment, IconButton} from '@material-ui/core';
import * as Yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {useLocation} from 'react-router-dom';
import {useHistory} from 'react-router';
import {postResetPassword} from '../../../redux/reducers/forgotPassword';
import {resetMsg, resetStatus} from '../../../redux/reducers/forgotPassword';

const ResetPassword = () => {
  const [newPasswordShown, setNewPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);

  const toggleNewPassword = () => {
    setNewPasswordShown(!newPasswordShown);
  };
  const toggleConfirmPassword = () => {
    setConfirmPasswordShown(!confirmPasswordShown);
  };
  const {isLoading, successMsg, errorMsg, mailStatus} = useSelector(
    ({forgotPassword}) => forgotPassword,
  );

  const history = useHistory();

  const initialValues = {
    newPassword: '',
    confirmPassword: '',
  };

  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetMsg());
        dispatch(resetStatus());
      }, 3000);
    }
    if (mailStatus === 200) {
      setTimeout(() => {
        history.push('/login');
      }, 3200);
    }
  }, [successMsg, errorMsg, mailStatus]);

  const validationSchema = Yup.object().shape({
    newPassword: Yup.string()
      .required('Please enter your new password')
      .matches(
        /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
        'New password must contain at least 8 characters, one uppercase, one lower case, one numeric and one special case character',
      ),
    confirmPassword: Yup.string()
      .required('Please confirm your new password')
      .oneOf([Yup.ref('newPassword'), null], 'Confirm password and new password must match'),
  });
  const {handleSubmit, errors, register} = useForm({
    mode: 'onSubmit',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });
  const dispatch = useDispatch();
  const search = useLocation().search;
  const token = new URLSearchParams(search).get('token');

  const handleResetPassword = (data) => {
    const values = {
      confirmPassword: data.confirmPassword,
      newPassword: data.newPassword,
      token: token,
    };
    if (data) {
      dispatch(postResetPassword(values));
    }
  };
  return (
    <div className="App">
      <div className="login-page">
        <div className="main-content">
          <div className="company-logo">
            <img src={Navigation} alt="navigation-logo" />
          </div>
          <div className="form-content">
            <h4 role="heading" aria-level="1">
              Reset Password
            </h4>
            <p>Please choose a New Password</p>
            <form onSubmit={handleSubmit(handleResetPassword)}>
              <div
                className={`form-group reset-password-fields ${
                  errors.newPassword?.message.length > 30 ? 'mb-5' : ''
                }`}
              >
                <label>NEW PASSWORD</label>
                <TextField
                  type={newPasswordShown ? 'text' : 'password'}
                  margin="dense"
                  variant="outlined"
                  style={{marginTop: '20px'}}
                  className="form-control"
                  name="newPassword"
                  inputRef={register}
                  fullWidth
                  error={Boolean(errors.newPassword?.message)}
                  InputProps={{
                    // <-- This is where the toggle button is added.
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={toggleNewPassword}
                        >
                          {newPasswordShown ? (
                            <Visibility color="primary" />
                          ) : (
                            <VisibilityOff color="primary" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <FormHelperText style={{color: 'red', lineHeight: '1rem'}} variant="outlined">
                  {errors.newPassword?.message ? errors.newPassword.message : ''}
                </FormHelperText>
              </div>
              <div
                className={`form-group reset-password-fields ${
                  errors.confirmPassword?.message.length > 35 ?
                    'confirm-password-fields' :
                    ''
                }`}
              >
                <label>CONFIRM PASSWORD</label>
                <TextField
                  type={confirmPasswordShown ? 'text' : 'password'}
                  margin="dense"
                  variant="outlined"
                  className="form-control"
                  name="confirmPassword"
                  inputRef={register}
                  fullWidth
                  error={Boolean(errors.confirmPassword?.message)}
                  InputProps={{
                    // <-- This is where the toggle button is added.
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={toggleConfirmPassword}
                        >
                          {confirmPasswordShown ? (
                            <Visibility color="primary" />
                          ) : (
                            <VisibilityOff color="primary" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <FormHelperText style={{color: 'red'}} variant="outlined">
                  {errors.confirmPassword?.message ? errors.confirmPassword.message : ''}
                </FormHelperText>
              </div>
              <button type="submit" className="login-btn btn-block">
                RESET PASSWORD
              </button>
            </form>
          </div>
        </div>
        <div className="copyright">
          <p style={{color: '#000'}}>&copy;2021 PDS Galaxy</p>
        </div>
      </div>
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
};

export default ResetPassword;
